<!--
 * @Description:不可编辑详情页组件
 * @Author: ll
 * @Date: 2021-9-13 14:01:30
 * @LastEditTime: 
 * @LastEditors: ll
-->
<template>
  <div class="detailCont">
    <!-- 软件基本信息 -->
    <div class="cr-basic">
      <div class="cr-title cr-ai-center cr-mb-2">
        <span class="cr-bang cr-in-block cr-bg-primary"></span>
        <span class="cr-text-black-1">软件基本信息</span>
      </div>
      <div class="cr-info cr-flex">
        <div class="cr-infos">
          <p>
            <span class="cr-span1">软件全称：</span><span class="cr-span2">{{ detailData.fullName }}</span>
          </p>
          <p>
            <span class="cr-span4">软件简称：</span><span class="cr-span2">{{ detailData.shortName }}</span>
          </p>
          <p>
            <span class="cr-span1">版本号：</span><span class="cr-span2">{{ detailData.versionNo }}</span>
          </p>
          <p>
            <span class="cr-span1">软件分类：</span>
            <span class="cr-span2">{{ detailData.category }} </span>
          </p>
        </div>
        <div class="cr-infos">
          <p>
            <span class="cr-span1">开发完成日期：</span><span class="cr-span2">{{ detailData.completionDate }}</span>
          </p>
          <p>
            <span class="cr-span1">发表状态：</span><span class="cr-span2">{{ detailData.publishState }}</span>
          </p>
          <p v-show="detailData.publishState !== '未发表'">
            <span class="cr-span1">首次发表日期：</span><span class="cr-span2">{{ detailData.firstPublishDate }}</span>
          </p>
          <p v-show="detailData.publishState !== '未发表'">
            <span class="cr-span1">首次发表地址：</span><span class="cr-span2">{{ detailData.firstPublishAddress }}</span>
          </p>
        </div>
      </div>
    </div>
    <!-- 软件技术特点 -->
    <div class="cr-basic cr-mt-3">
      <div class="cr-title cr-ai-center cr-mb-2">
        <span class="cr-bang cr-in-block cr-bg-primary"></span>
        <span class="cr-text-black-1">软件技术特点</span>
      </div>
      <div class="cr-info">
        <div class="cr-infos cr-infos1">
          <p>
            <span class="cr-span1">开发硬件环境：</span><span class="cr-span2">{{ detailData.developHardware || '-' }}</span>
          </p>
          <p>
            <span class="cr-span1">运行硬件环境：</span><span class="cr-span2">{{ detailData.productHardware || '-' }}</span>
          </p>
          <p>
            <span class="cr-span1">开发操作系统：</span><span class="cr-span2">{{ detailData.developOs || '-' }}</span>
          </p>
          <p>
            <span class="cr-span1">软件开发环境：</span><span class="cr-span2">{{ detailData.developTools || '-' }}</span>
          </p>
          <p>
            <span class="cr-span1">软件运行平台：</span><span class="cr-span2">{{ detailData.operatingPlatform || '-' }}</span>
          </p>
          <p>
            <span class="cr-span1">软件支撑环境：</span><span class="cr-span2">{{ detailData.supportingEnv || '-' }}</span>
          </p>
          <p>
            <span class="cr-span1">编程语言：</span><span class="cr-span2">{{ detailData.programmingLanguage || '-' }}</span>
          </p>
          <p>
            <span class="cr-span1">源程序量：</span><span class="cr-span2">{{ detailData.sourceCodeCount || '-' }}</span>
          </p>
          <p>
            <span class="cr-span1">开发目的：</span><span class="cr-span2">{{ detailData.developPurpose || '-' }}</span>
          </p>
          <p>
            <span class="cr-span1">面向领域/行业：</span><span class="cr-span2">{{ detailData.fieldOriented || '-' }}</span>
          </p>
          <p>
            <span class="cr-span1">软件属性：</span><span class="cr-span2">{{ detailData.attributes || '-' }}</span>
          </p>
          <p>
            <span class="cr-span1">软件主要功能：</span><span class="cr-span2">{{ detailData.primaryFunction || '-' }}</span>
          </p>
          <p>
            <span class="cr-span1">软件技术特点：</span><span class="cr-span2">{{ detailData.technicalFeature || '-' }}</span>
          </p>
        </div>
      </div>
    </div>
    <!-- 著作权人信息 -->
    <div class="cr-basic cr-mt-3">
      <div class="cr-title cr-ai-center cr-mb-2">
        <span class="cr-bang cr-in-block cr-bg-primary"></span>
        <span class="cr-text-black-1">著作权人信息</span>
      </div>
      <div class="cr-infos2">
        <div class="cr-info1 cr-text-black-1"><span>著作权人名称</span><span>类型</span><span>纳税号/身份证号</span><span>操作</span></div>
        <div class="cr-info1 cr-bg-white-1 cr-text-black-1" v-for="item in detailData.authors" :key="item.id">
          <span>{{ item.ownerName }}</span>
          <span class="span-center"
            ><span class="cr-tabs">{{ item.category | filterCate }}</span></span
          >
          <span>{{ (item.category === 5 || item.category === 4 ? item.idCard : item.socialCreditCode) || '-' }}</span>
          <span class="cr-cursor span-center" @click="getcopyDetail(item.id)"><a>查看详情</a></span>
        </div>
      </div>
    </div>
    <!-- 联系人信息 -->
    <div class="cr-basic cr-mt-3">
      <div class="cr-title cr-ai-center cr-mb-2">
        <span class="cr-bang cr-in-block cr-bg-primary"></span>
        <span class="cr-text-black-1">联系人信息</span>
      </div>
      <div class="cr-info cr-flex">
        <div class="cr-infos">
          <p>
            <span class="cr-span1">联系人：</span><span class="cr-span2">{{ detailData.contactPerson || '-' }}</span>
          </p>
          <p>
            <span class="cr-span1">邮政编码：</span><span class="cr-span2">{{ detailData.postalCode || '-' }}</span>
          </p>
          <p>
            <span class="cr-span1">邮寄地址：</span><span class="cr-span2">{{ detailData.postalAddress }}</span>
          </p>
        </div>
        <div class="cr-infos">
          <p>
            <span class="cr-span1">联系电话：</span><span class="cr-span2">{{ detailData.contactPhone || '-' }}</span>
          </p>
          <p>
            <span class="cr-span1">电子邮箱：</span><span class="cr-span2">{{ detailData.contactEmail || '-' }}</span>
          </p>
          <p>
            <span class="cr-span4">座机电话：</span><span class="cr-span2">{{ detailData.contactLanline || '-' }}</span>
          </p>
        </div>
      </div>
    </div>
    <!-- 软件鉴别材料 -->
    <div class="cr-basic cr-mt-3 cr-mb-4">
      <div class="cr-title cr-ai-center cr-mb-2">
        <span class="cr-bang cr-in-block cr-bg-primary"></span>
        <span class="cr-text-black-1">软件鉴别材料</span>
      </div>
      <div class="cr-info">
        <div class="cr-infos cr-infos1">
          <p><span class="cr-span1">软件说明文档：</span><a :href="detailData.softwareDocument">下载文件</a><span class="cr-text-black-1" v-if="!detailData.includingEnglish === 2">（含有英文）</span></p>
          <p><span class="cr-span1">软件源代码：</span><a :href="detailData.scoreCode">下载文件</a></p>
        </div>
      </div>
    </div>
    <!-- 其他材料 -->
    <div class="cr-basic cr-mb-4" v-if="detailData.includingEnglish == 1 || detailData.cooperativeAgreement">
      <div class="cr-title cr-ai-center cr-mb-2">
        <span class="cr-bang cr-in-block cr-bg-primary"></span>
        <span class="cr-text-black-1">其他材料</span>
      </div>
      <div class="cr-info">
        <div class="cr-infos cr-infos1">
          <p v-if="detailData.cooperativeAgreement"><span class="cr-span1">合作开发协议：</span><a :href="detailData.cooperativeAgreement">下载文件</a></p>
          <p v-if="detailData.nameExplanation"><span class="cr-span1">名称英文解释：</span><a :href="detailData.nameExplanation">下载文件</a></p>
          <p v-if="detailData.includingEnglish == 1"><span class="cr-span1">说明书英文解释：</span><a :href="detailData.manualExplanation">下载文件</a></p>
        </div>
      </div>
    </div>
    <!-- 著作权人信息弹框 -->
    <copy-info :copyVisible.sync="copyVisible" :copyData="copyData" />
  </div>
</template>

<script>
import copyInfo from './copyInfo.vue'
import { copyDetail, detailInfo } from '@/api/cannotEdit.js'
export default {
  filters: {
    filterCate(val) {
      const statusList = {
        1: '企业单位',
        2: '事业单位',
        3: '分公司',
        4: '自然人',
        5: '未成年人'
      }
      return statusList[val]
    }
  },
  props: {
    caseNo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      copyVisible: false,
      copyData: {}, // 著作权人信息
      detailData: {}
    }
  },
  components: {
    copyInfo
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      const res = await detailInfo(this.caseNo)
      this.detailData = res.data
    },
    // 获取著作权人信息
    async getcopyDetail(idx) {
      this.copyVisible = true
      let data = {
        id: idx
      }
      const res = await copyDetail(data)
      this.copyData = res.data
      console.log(this.copyData)
    },
    // 下载文件
    downFile(url) {
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', '')
      document.body.appendChild(link)
      link.click
    }
  }
}
</script>

<style lang="less" scoped>
.detailCont {
  .cr-basic {
    .cr-title {
      .cr-bang {
        width: 3px;
        height: 14px;
        margin-right: 7px;
      }
    }
    .cr-info {
      .cr-infos {
        color: #333;
        width: 50%;
        p {
          margin-bottom: 20px;
          .cr-span1 {
            display: inline-block;
            width: 120px;
            text-align: left;
            white-space: nowrap;
            &::before {
              display: inline-block;
              content: '*';
              color: #ff4d4f;
              font-size: 14px;
              margin-right: 4px;
            }
          }
          .cr-span2 {
            color: #666;
            line-height: 20px;
          }
          .cr-span4 {
            width: 120px;
            display: inline-block;
            text-align: left;
            white-space: nowrap;
            padding-left: 11px;
          }
        }
      }
      .cr-infos1 {
        width: 100%;
      }
    }
    .cr-infos2 {
      width: 1106px;
      border-radius: 1px;
      border: 1px solid #f0f0f0;
      border-bottom: none;
      .cr-info1 {
        height: 40px;
        background: #fafafa;
        border-bottom: 1px solid #f0f0f0;
        .span-center {
          text-align: center;
        }
        span {
          display: inline-block;
          width: 25%;
          text-align: left;
          line-height: 40px;
          border-right: 1px solid #f0f0f0;
          padding: 0 20px;
          &:last-of-type {
            border-right: none;
          }
          .cr-tabs {
            display: inline-block;
            padding: 0;
            width: 80px;
            height: 22px;
            background: rgba(22, 100, 255, 0.1);
            color: #1664ff;
            border-radius: 2px;
            line-height: 22px;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
